import React, { ChangeEvent, FC } from "react";

interface Props {
  label: string;
  required?: boolean;
  type: "text" | "email" | "tel" | "url" | "textarea";
  value: string;
  inputAttrs?: any;
  onChange: (value: string) => void;
  errorMessage?: string;
}

export const FormText: FC<Props> = ({
  label,
  required,
  type,
  value,
  inputAttrs,
  onChange,
  errorMessage,
}) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  return (
    <div className={`formText_${type}`}>
      <label className="formText">
        <span className="formText--label">
          {label} {!required && <span>(Optional)</span>}
        </span>
        {type === "textarea" ? (
          <textarea
            value={value}
            {...inputAttrs}
            onChange={handleChange as any}
          />
        ) : (
          <input
            type={type}
            value={value}
            {...inputAttrs}
            onChange={handleChange}
          />
        )}
      </label>
      {errorMessage && <span className="formText--error">{errorMessage}</span>}
    </div>
  );
};
